import { useEffect, useRef } from 'react'
import { clearEnrollmentStore, useEnrollmentStore } from '@/stores'
import { clearEnrollmentBrowserState } from '../../state/enrollmentBrowserStorage'

type UseSponsoredEnrollmentSessionBootstrapArgs = {
  sessionToken: string
  onBeforeBootstrap?: () => void
}

export function useSponsoredEnrollmentSessionBootstrap({
  sessionToken,
  onBeforeBootstrap
}: UseSponsoredEnrollmentSessionBootstrapArgs) {
  const storedSessionToken = useEnrollmentStore(state => state.sessionToken)
  const setSessionToken = useEnrollmentStore(state => state.setSessionToken)
  const processedUrlSessionTokenRef = useRef<string | null>(null)

  useEffect(() => {
    if (!sessionToken) {
      return
    }

    if (processedUrlSessionTokenRef.current === sessionToken) {
      return
    }

    if (storedSessionToken !== sessionToken) {
      clearEnrollmentStore()
      clearEnrollmentBrowserState()
    }

    onBeforeBootstrap?.()
    setSessionToken(sessionToken)
    processedUrlSessionTokenRef.current = sessionToken
  }, [onBeforeBootstrap, sessionToken, setSessionToken, storedSessionToken])
}
